var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoXl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300.74,
    height: 80,
    viewBox: "0 0 300.74 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-xl",
    transform: "translate(-168 -77.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M203.108,77.315H213.5V97.549c-3.9,2.154-6.671-1.6-10.532-1.663C203.062,89.742,202.785,83.229,203.108,77.315Z",
    transform: "translate(3.144 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M190.882,79.985v15.8c-4.355-.778-6.068,2.969-10.533,2.08-.23-5.637-.232-12.241,0-17.879Z",
    transform: "translate(1.095 0.24)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M224.888,83.419V97.694c-3.527.109-4.226-2.588-8.038-2.356a6.57,6.57,0,0,0-3.187,1.108,122.489,122.489,0,0,1,0-13.027Z",
    transform: "translate(4.111 0.549)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M180.472,86.979v9.286c-.231.567-.682-.263-.97-.415a9.108,9.108,0,0,0-4.434-.832c-2.572.251-4.4,2.411-7.068,2.357V86.98Z",
    transform: "translate(0 0.869)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M203.234,90.552V94.71c-2.14.038-3.623,2.039-5.544,2.356-2.808.464-4.388-1.513-6.93-1.94V90.415C194.873,90.505,199.352,90.232,203.234,90.552Z",
    transform: "translate(2.048 1.182)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M180.472,98.831v22.451H168V99.246c2.911.471,4.833-1.912,7.207-2.218C177.507,96.732,178.831,97.83,180.472,98.831Z",
    transform: "translate(0 1.78)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M190.879,97.156v17.462H180.207V99.235C185.076,100.467,186.639,96.547,190.879,97.156Z",
    transform: "translate(1.098 1.789)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M203.095,97.151c.324,8.732.047,18.063.139,27.024H190.761V97.428c2.276,1.068,3.849,2.254,6.514,1.94C199.582,99.1,201.4,97.141,203.095,97.151Z",
    transform: "translate(2.048 1.797)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M213.361,98.688c.324,3.788.047,8.177.138,12.2H202.967V97.024C206.012,97.849,209.6,100.752,213.361,98.688Z",
    transform: "translate(3.146 1.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M224.885,99.245v17.324H213.521V98.137a7.836,7.836,0,0,1,2.495-1.11C219.29,96.607,221.312,99.656,224.885,99.245Z",
    transform: "translate(4.114 1.78)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M268.862,83.246c-1.2,2.822-2.738,5.3-4.019,8.038-1.635-.839-4.339-2.869-7.623-2.5-1.982.227-4.209,1.588-3.742,3.881a4.206,4.206,0,0,0,2.357,2.495c2.155,1.064,4.91,1.293,7.345,2.356,4.7,2.05,7.823,4.808,7.346,11.92a16.509,16.509,0,0,1-1.386,5.682c-4.359,8.869-20.277,8.987-28.134,2.495,1.287-2.964,2.971-5.529,4.3-8.455,2.448,1.676,5.682,4.855,10.533,4.157,1.954-.28,4.423-1.946,3.743-4.712-.616-2.5-4.967-3.456-7.623-4.3-3.3-1.045-7.113-2.414-8.454-5.128a14.228,14.228,0,0,1-.971-7.207,12.978,12.978,0,0,1,11.92-11.92C260.536,79.523,264.252,81.281,268.862,83.246Z",
    transform: "translate(6.601 0.238)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M445.88,80.814v40.191H440.2v-2.772c-.89.576-1.72,1.854-2.773,2.495a11.487,11.487,0,0,1-7.067,1.248c-5.288-.668-8.975-5.113-9.424-10.95-.609-7.9,2.725-15.618,11.226-15.521a8.491,8.491,0,0,1,8.039,4.573c.093-6.376-.184-13.121.138-19.264Zm-13.859,19.957c-4.8.8-6.635,8.225-4.3,12.888,1.617,3.227,6.917,4.5,9.979,1.94,3.879-3.236,3.246-11.17.138-13.72a6.833,6.833,0,0,0-5.544-1.108C432.207,100.786,432.111,100.756,432.021,100.771Z",
    transform: "translate(22.86 0.315)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M272.681,80.941h22.73V89.81h-12.2c-.324,1.9-.047,4.388-.141,6.515,3.651.323,7.9.046,11.781.138v8.871H283.216c-.324,1.94-.047,4.48-.141,6.652,3.837.323,8.271.046,12.336.14v8.869H272.543C272.635,107.688,272.358,94.014,272.681,80.941Z",
    transform: "translate(9.449 0.326)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M322.95,80.941c5.033,13.306,9.963,26.718,15.106,39.914-3.465.324-7.529.046-11.225.138-.807-2.336-1.782-4.5-2.495-6.929H310.059c-1.045,2.188-1.91,4.558-2.77,6.929H296.063c5.153-13.326,10.319-26.638,15.384-40.053h11.5Zm-10.116,25.084c2.816-.092,6,.184,8.592-.138-1.554-4.036-2.743-8.436-4.3-12.472C315.675,97.594,314.332,101.888,312.834,106.025Z",
    transform: "translate(11.581 0.326)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M343.98,81.449c4.462,9.536,9.267,18.729,13.167,28.827q6.569-14.425,13.166-28.827c3.32,12.942,6.185,26.338,9.286,39.5h-5.821c-1.467-7.864-3.834-14.829-4.712-23.283a3.619,3.619,0,0,0-.693,1.662,30.635,30.635,0,0,1-2.079,4.713c-3.043,6.051-5.843,12.2-8.87,18.432a11.006,11.006,0,0,1-1.662-3.049c-1.458-2.947-2.957-6.133-4.435-9.286-1.917-4.088-4.31-8.1-5.683-12.611-1.328,8.1-3.33,15.518-4.849,23.421h-5.821C338,107.8,340.9,94.542,343.98,81.449Z",
    transform: "translate(15.101 0.372)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M380.633,82.848h6.1v37.973h-6.237V83.263C380.48,83.067,380.472,82.872,380.633,82.848Z",
    transform: "translate(19.204 0.498)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M417.683,119.8h-5.822c-.248-4.245.325-10.442,0-14.967-.244-3.415-1.385-5.506-4.85-5.682-2.887-.147-6.061,1.348-6.929,3.743-1.5,4.124-.012,11.733-.554,16.907h-5.684V95.266h5.406v3.6a11.272,11.272,0,0,1,8.455-4.573c3.042-.208,5.836.535,7.483,1.94C419.965,100.312,416.7,111.959,417.683,119.8Z",
    transform: "translate(20.429 1.535)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M418.824,126.818c-.679,1.144,3.581,1.475,3.154.53-.388-.265-.672.28-1.09-.214.886-1.185,1.783-.411,2.549.558C423.8,127.985,418.435,126.312,418.824,126.818Z",
    transform: "translate(22.67 4.448)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M248.127,129.024q3.285,2.922,6.33,6.083v-5.836h1.367v8.689c-.035.457-.568-.2-.747-.372-1.765-1.657-3.946-3.834-5.709-5.586v5.958h-1.241Q248.127,133.494,248.127,129.024Z",
    transform: "translate(7.242 4.676)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M275.393,129.891v1.488c-1.34-1.348-4.33-1.263-5.339.125a3.375,3.375,0,0,0,2.359,5.338,5.944,5.944,0,0,0,2.856-.992v1.489a4.665,4.665,0,0,1-7.325-3.724C267.923,129.991,271.969,127.749,275.393,129.891Z",
    transform: "translate(9.033 4.678)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M279.33,129.024a92.807,92.807,0,0,1,4.219,8.938h-1.488c-.2-.836-.689-1.381-.87-2.234H277.84a9.889,9.889,0,0,0-1.116,2.234h-1.49C276.52,134.9,278.006,132.044,279.33,129.024Zm-.993,5.462h2.234a29.133,29.133,0,0,0-1.241-2.731C279.187,132.853,278.562,133.47,278.337,134.486Z",
    transform: "translate(9.692 4.675)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M295.75,129.138a4.578,4.578,0,0,1,4.717,6.206,4.865,4.865,0,0,1-7.7,1.49,4.458,4.458,0,0,1,2.98-7.7Zm.372,7.7a3.419,3.419,0,0,0,3.1-2.482,3.141,3.141,0,0,0-3.6-3.849C291.6,131.1,292.68,136.853,296.122,136.835Z",
    transform: "translate(11.155 4.685)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M318.384,130.512c-.794,1.122-1.466-.268-2.358-.249a1.121,1.121,0,0,0-1.243.994c-.12,1.525,3.49,1.935,3.848,3.475.819,3.515-4.62,4.815-5.585,1.366a2.195,2.195,0,0,0,.992-.5c.455,1.47,3.226,1.731,3.227,0,0-1.621-3.244-1.682-3.848-3.226C312.244,129.371,317.144,127.619,318.384,130.512Z",
    transform: "translate(13.109 4.677)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M341.559,129.024c.145-.021.221.027.25.123.958,2.063,1.95,4.093,2.855,6.206.784-1.535,1.477-3.195,2.234-4.841a3.59,3.59,0,0,1,.87-1.489c.561,3.081,1.4,5.881,1.986,8.938h-1.241a32.851,32.851,0,0,1-1.117-5.214c-.871,1.82-1.773,3.607-2.607,5.462-1.116-1.573-1.738-3.642-2.733-5.338-.413,1.656-.741,3.4-1.115,5.089H339.7C340.145,134.81,341.071,132.135,341.559,129.024Z",
    transform: "translate(15.518 4.675)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M353.828,129.139a4.462,4.462,0,0,1,5.089,4.47,4.66,4.66,0,1,1-9.31-.373,4.31,4.31,0,0,1,1.241-2.856A4.4,4.4,0,0,1,353.828,129.139Zm-2.73,4.1a3.185,3.185,0,1,0,2.606-2.73A2.908,2.908,0,0,0,351.1,133.236Z",
    transform: "translate(16.413 4.684)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M359.518,129.024c2.318,1.861,4.34,4.019,6.455,6.083v-5.836h1.366v8.689c-.082.591-.458-.372-.746-.372-1.888-1.878-3.9-3.627-5.709-5.586v5.958H359.64C359.353,135.228,359.6,131.964,359.518,129.024Z",
    transform: "translate(17.307 4.676)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M380.706,129.139a4.463,4.463,0,0,1,5.09,4.47,4.66,4.66,0,1,1-9.31-.373,4.316,4.316,0,0,1,1.242-2.856A4.4,4.4,0,0,1,380.706,129.139Zm-2.729,4.1a3.185,3.185,0,1,0,2.608-2.73A2.909,2.909,0,0,0,377.977,133.236Z",
    transform: "translate(18.842 4.684)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M405.3,129.024c1.421,2.924,2.87,5.822,4.1,8.938h-1.366a16.785,16.785,0,0,1-.992-2.234h-3.353a20.327,20.327,0,0,0-1.117,2.234H401.2A96.04,96.04,0,0,1,405.3,129.024Zm-1.115,5.462h2.233c-.224-.932-.783-1.535-.992-2.482-.027-.1-.1-.146-.25-.125A21.082,21.082,0,0,1,404.181,134.486Z",
    transform: "translate(21.091 4.675)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M416.612,129.9a7.341,7.341,0,0,1-.124,1.488c-1.733-1.827-5.552-1.016-5.832,1.738a3.149,3.149,0,0,0,2.977,3.724,6.782,6.782,0,0,0,2.855-.992v1.489a5.7,5.7,0,0,1-2.73.868c.906-.034,2.179,1.152,1.242,1.987-.556.495-2.527.476-2.731-.373.274-.621,1.574.435,1.986-.249.148-.688-.441-.633-.992-.621v-.869c-5.783-.36-5.138-9.594.992-9.062A6.331,6.331,0,0,1,416.612,129.9Z",
    transform: "translate(21.817 4.674)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M420.559,129.024a92.594,92.594,0,0,1,4.1,8.938h-1.366c-.349-.726-.678-1.473-.992-2.234h-3.352c-.458.662-.693,1.543-1.116,2.234h-1.366C417.681,134.837,419.154,131.964,420.559,129.024Zm-1.119,5.462h2.236a23.771,23.771,0,0,0-1.116-2.731A23.778,23.778,0,0,1,419.44,134.486Z",
    transform: "translate(22.464 4.675)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M428.656,129.139a4.461,4.461,0,0,1,5.089,4.47,4.66,4.66,0,1,1-9.309-.373,4.316,4.316,0,0,1,1.242-2.856A4.4,4.4,0,0,1,428.656,129.139Zm-2.731,4.1a3.186,3.186,0,1,0,2.607-2.73A2.91,2.91,0,0,0,425.925,133.236Z",
    transform: "translate(23.181 4.684)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M246.428,129.251c-.082,2.858.162,6.039-.124,8.689h-1.366v-8.689Z",
    transform: "translate(6.953 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M257.012,137.943c.083-2.855-.166-6.041.125-8.689,2.028.149,3.41-.286,4.841.247,2.824,1.056,3.135,5.615,1.117,7.45C261.794,138.132,259.6,137.89,257.012,137.943Zm5.463-2.483c.815-1.348.449-3.855-.746-4.593-.9-.556-1.89-.272-3.352-.373v6.083C260.126,136.548,261.668,136.793,262.475,135.46Z",
    transform: "translate(8.043 4.694)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M266.7,129.251c-.081,2.858.164,6.039-.123,8.689h-1.366v-8.689Z",
    transform: "translate(8.785 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M283.664,137.941c.082-2.855-.166-6.041.123-8.689,2.5.147,4.2-.39,5.71.746,2.282,1.721,1.881,6.238-.5,7.448C287.616,138.152,285.85,137.836,283.664,137.941Zm4.716-1.737c1.34-.863,1.687-4.068.124-5.213-.971-.714-2-.4-3.476-.5v6.083C286.522,136.5,287.494,136.775,288.38,136.2Z",
    transform: "translate(10.452 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M301.43,129.254c1.568.22,2.931-.428,4.1.373,1.5,1.033,1.044,4.321-.993,4.345.507,1.232,2.068,2.483,2.732,3.972h-1.49a38.257,38.257,0,0,0-2.979-3.849v3.726c-.266.229-.91.084-1.365.123Q301.43,133.6,301.43,129.254Zm1.488,3.724a3.008,3.008,0,0,0,1.864-.5c.522-1.4-.429-2.27-1.987-1.987A9.759,9.759,0,0,0,302.918,132.979Z",
    transform: "translate(12.059 4.693)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M307.58,129.251h4.839v1.242h-3.227c-.288.458-.043,1.447-.123,2.111h3.351v1.241h-3.227a11.588,11.588,0,0,0-.123,2.73h3.351v1.365a37.19,37.19,0,0,1-4.839-.123Z",
    transform: "translate(12.614 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M322.957,137.943c.082-2.855-.166-6.041.124-8.689,2.028.149,3.412-.286,4.842.247,2.822,1.056,3.133,5.615,1.116,7.45C327.742,138.132,325.545,137.89,322.957,137.943Zm5.463-2.483c.814-1.348.449-3.855-.745-4.593-.9-.556-1.89-.272-3.352-.373v6.083C326.071,136.548,327.612,136.793,328.42,135.46Z",
    transform: "translate(14.003 4.694)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M331.155,129.251H336v1.242h-3.351c-.288.458-.045,1.447-.123,2.111H336v1.241h-3.351a11.473,11.473,0,0,0-.123,2.73H336v1.365h-4.84Q331.154,133.6,331.155,129.251Z",
    transform: "translate(14.745 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M369.878,129.251v8.689h-1.366v-8.689Z",
    transform: "translate(18.12 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M376.75,129.251v1.241h-2.112c-.289,2.234-.04,5.007-.122,7.448-.493-.046-1.191.113-1.49-.123v-7.326H370.79V129.25Z",
    transform: "translate(18.327 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M386.394,129.253c1.91.013,4.228-.314,4.842,1.241.529,1.342-.063,3.517-1.74,3.477.844,1.433,2.042,2.51,2.857,3.972h-1.49c-1.035-1.238-1.912-2.641-2.979-3.849a23.145,23.145,0,0,0-.124,3.849c-.457-.039-1.1.107-1.366-.123Zm1.49,1.241v2.483a4.023,4.023,0,0,0,1.863-.372,1.979,1.979,0,0,0,0-1.738A2.9,2.9,0,0,0,387.884,130.494Z",
    transform: "translate(19.738 4.694)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M394.148,129.251c-.082,2.858.163,6.039-.124,8.689h-1.366v-8.689Z",
    transform: "translate(20.323 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M401.506,129.251c-1.325,2.523-2.876,4.82-4.22,7.325h4.344v1.365H395.05c1.259-2.589,2.824-4.871,4.22-7.323a18.8,18.8,0,0,0-3.475-.124c-.22-.234-.09-.82-.124-1.242Z",
    transform: "translate(20.538 4.696)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M282.717,140.3c-.746.58-.937,1.71-2.359,1.613C280.974,141.21,281.077,139.987,282.717,140.3Z",
    transform: "translate(10.154 5.692)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M268.4,142.236q3.309,3.023,6.455,6.207v-5.959H276.1v8.69c-.058.452-.533-.2-.745-.372-1.826-1.511-3.836-3.791-5.586-5.463v5.836H268.4Z",
    transform: "translate(9.074 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M288.163,142.236c1.031,2.113,2.074,4.216,2.979,6.455,1.015-2.132,1.95-4.34,2.98-6.455.8,2.883,1.413,5.951,2.11,8.938h-1.365c-.232-1.839-.875-3.264-.994-5.213-.4.96-.909,1.93-1.367,2.856a9.663,9.663,0,0,1-1.488,2.605c-.645-1.921-1.762-3.369-2.359-5.336a42.38,42.38,0,0,0-1.241,5.089h-1.366C286.838,148.275,287.377,145.13,288.163,142.236Z",
    transform: "translate(10.67 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M310.537,142.236a91.275,91.275,0,0,1,4.22,8.938h-1.49c-.2-.837-.688-1.381-.869-2.235h-3.352a8.829,8.829,0,0,0-.993,2.235h-1.613C307.794,148.182,309.278,145.322,310.537,142.236Zm-.993,5.585h2.233c-.2-1-.783-1.615-.992-2.607-.026-.1-.1-.144-.248-.123C310.424,146.218,309.749,146.786,309.544,147.821Z",
    transform: "translate(12.512 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M348.009,142.236a90.766,90.766,0,0,1,4.219,8.938h-1.49c-.2-.837-.688-1.381-.869-2.235h-3.352a8.9,8.9,0,0,0-.992,2.235h-1.614C345.265,148.182,346.75,145.322,348.009,142.236Zm-.994,5.585h2.233c-.2-1-.782-1.615-.991-2.607-.028-.1-.106-.144-.249-.123C347.894,146.218,347.22,146.786,347.015,147.821Z",
    transform: "translate(15.899 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M373.179,142.236c1.512,2.749,2.791,5.731,4.1,8.69a21.121,21.121,0,0,0,1.117-4.345c.327-1.442.737-2.908.993-4.345a46.766,46.766,0,0,1,2.979,6.455c1.08-2.065,2.021-4.269,2.979-6.455.955,2.727,1.349,6.016,2.236,8.813-.214.284-.948.046-1.366.124-.386-1.684-.8-3.342-1.117-5.089-.735,1.871-1.821,3.391-2.483,5.336a8.606,8.606,0,0,1-1.489-2.605,18.023,18.023,0,0,1-1.243-2.856c-.429,1.681-.822,3.4-1.116,5.213H375.91c-.316-.761-.62-1.532-.994-2.235H371.69a15.723,15.723,0,0,0-1.117,2.235h-1.489C370.41,148.156,371.875,145.276,373.179,142.236Zm-.993,5.585h2.234a15.194,15.194,0,0,0-1.241-2.73C373.037,146.19,372.36,146.755,372.186,147.821Z",
    transform: "translate(18.177 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M402.452,142.236q3.35,2.98,6.457,6.207v-5.959h1.241c.288,2.733.041,6,.124,8.937-2.319-1.859-4.341-4.018-6.456-6.082v5.836h-1.367Z",
    transform: "translate(21.204 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M419.192,142.236a91.018,91.018,0,0,1,4.219,8.938h-1.489c-.2-.837-.687-1.381-.87-2.235H417.7a8.868,8.868,0,0,0-.993,2.235H415.1C416.449,148.182,417.933,145.322,419.192,142.236Zm-.994,5.585h2.234c-.2-1-.783-1.615-.993-2.607-.027-.1-.1-.144-.247-.123C419.078,146.218,418.4,146.786,418.2,147.821Z",
    transform: "translate(22.341 5.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M257.85,143.1v1.489a5.126,5.126,0,0,0-2.731-.994c-3.832.037-4.212,5.807-.87,6.456a5.1,5.1,0,0,0,3.6-.993v1.489c-2.952,2.01-6.843.214-7.325-2.731C249.83,143.569,253.988,141,257.85,143.1Z",
    transform: "translate(7.452 5.88)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M262.224,142.469a4.494,4.494,0,1,1-3.476,6.207A4.516,4.516,0,0,1,262.224,142.469Zm.124,7.573c5.118.938,4.96-7.44-.124-6.208C259.042,144.606,259.49,149.518,262.349,150.042Z",
    transform: "translate(8.17 5.885)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M280.675,142.47a4.6,4.6,0,0,1,5.214,6.207,4.929,4.929,0,0,1-3.849,2.729c-3.214.278-6.464-2.952-4.716-6.579A4.927,4.927,0,0,1,280.675,142.47Zm-1.737,2.483a3.235,3.235,0,1,0,5.711,1.118,3.022,3.022,0,0,0-3.849-2.237A3.2,3.2,0,0,0,278.938,144.952Z",
    transform: "translate(9.837 5.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M306.718,143.221a3.582,3.582,0,0,0-.125,1.366c-3.355-2.69-6.9.649-5.586,3.724.732,1.721,3.884,2.4,5.586.744v1.612c-3.97,2.157-7.757-.674-7.323-4.469A4.765,4.765,0,0,1,306.718,143.221Z",
    transform: "translate(11.861 5.878)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M323.043,143.841c-.271.184-.668.243-.87.5-.409-.583-2.552-1.428-2.607.248-.057,1.742,3.748,1.64,3.849,3.972.131,3.013-4.816,4.265-5.587.746a2.459,2.459,0,0,0,.871-.373c.516.305.59.976,1.365,1.118.823.152,1.831-.187,1.862-1.118.059-1.689-3.256-1.745-3.849-3.352C317,142.66,321.876,140.867,323.043,143.841Z",
    transform: "translate(13.541 5.877)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M327.713,142.47a4.6,4.6,0,0,1,5.214,6.207,4.93,4.93,0,0,1-3.849,2.729c-3.214.278-6.464-2.952-4.717-6.579A4.934,4.934,0,0,1,327.713,142.47Zm-1.737,2.483a3.235,3.235,0,1,0,5.711,1.118,3.021,3.021,0,0,0-3.848-2.237A3.2,3.2,0,0,0,325.976,144.952Z",
    transform: "translate(14.088 5.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M341,143.224a2.667,2.667,0,0,1-.123,1.117c-.136.315-.622-.067-.746-.124-1.044-.488-2.839-.971-4.1.124-1.709,1.491-1.159,4.875.869,5.586a4.09,4.09,0,0,0,3.849-.869c.286.294.045,1.114.123,1.612a5.048,5.048,0,0,1-6.578-1.116,4.644,4.644,0,0,1,4.715-7.2A5.008,5.008,0,0,1,341,143.224Z",
    transform: "translate(14.956 5.875)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M244.938,142.463h4.842V143.7h-3.352c-.287.458-.045,1.447-.124,2.111h3.475v1.366h-3.352a11.522,11.522,0,0,0-.124,2.73h3.475v1.242h-4.842Q244.939,146.809,244.938,142.463Z",
    transform: "translate(6.953 5.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M297.907,142.465v8.69h-1.489v-8.317C296.382,142.18,297.394,142.571,297.907,142.465Z",
    transform: "translate(11.605 5.889)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M343.352,142.588v8.566h-1.491v-8.69C342.354,142.511,343.05,142.35,343.352,142.588Z",
    transform: "translate(15.712 5.89)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M353.829,142.588v7.325h3.105v1.241h-4.6v-8.69C352.833,142.511,353.529,142.35,353.829,142.588Z",
    transform: "translate(16.659 5.89)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M360.881,142.463h4.842V143.7H362.5c-.287.458-.044,1.447-.124,2.111h3.352v1.366H362.5a11.521,11.521,0,0,0-.124,2.73h3.352v1.242h-4.842Z",
    transform: "translate(17.431 5.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M387.077,142.465c2.109-.034,4.646-.191,5.09,1.49a2.176,2.176,0,0,1-.993,2.607c1.783.5,1.773,3.353.5,4.221-1.234.838-2.785.131-4.593.372Zm1.366,3.724a3.084,3.084,0,0,0,2.234-.5,2.645,2.645,0,0,0,0-1.49,3.084,3.084,0,0,0-2.234-.5Zm0,3.724c1.016.022,2.068.083,2.483-.5a2.529,2.529,0,0,0,0-1.615c-.415-.578-1.468-.518-2.483-.5Z",
    transform: "translate(19.799 5.889)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M394.822,142.463v8.69h-1.366v-8.69Z",
    transform: "translate(20.395 5.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M401.373,142.465v1.241h-3.229c-.288.458-.043,1.447-.124,2.111h3.353v1.366h-3.228a11.579,11.579,0,0,0-.124,2.73h3.353v1.241h-4.842v-8.566A37.6,37.6,0,0,1,401.373,142.465Z",
    transform: "translate(20.671 5.889)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M416.5,142.463V143.7h-2.11c-.29,2.235-.041,5.007-.123,7.449h-1.489V143.7h-2.234v-1.241Z",
    transform: "translate(21.931 5.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M425.013,142.588v7.325h3.1v1.241h-4.593v-8.69C424.016,142.511,424.713,142.35,425.013,142.588Z",
    transform: "translate(23.099 5.89)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXl);
export default __webpack_public_path__ + "static/media/logo-xl.54dd189b2a64de700635728a7a46ee66.svg";
export { ForwardRef as ReactComponent };